import * as React from "react";
import { useEffect, useState } from "react";
import { getSession, updateSession } from "../../libs/user";
import Modal from "../core/Modal";
import { jfetch } from "../../utils";


function BetaPopup() {
  const [show, setShow] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(3);
  const [html, setHtml] = useState('')
  const [updates, setUpdates] = useState([])
  const [view, setView] = useState([])
  const [showAll, setShowAll] = useState(false)
  const [hasMore, setHasMore] = useState(false)

  useEffect(() => {
    getSession().then(data => {
      if (!data.session.viewed_beta_popup) {
        setShow(true);
        setTimeout(() => setTimeRemaining(2), 1000);
        setTimeout(() => setTimeRemaining(1), 2000);
        setTimeout(() => setTimeRemaining(0), 3000);
      }
    });

    jfetch.get('/global_settings/show').then((resp) => {
      setHtml(resp.setting.intro_text)
    })
    
    jfetch.get('/global_settings/index_software').then((resp) => {
      setUpdates(resp.core_updates)
      setView(resp.core_updates.slice(0, 3))
      if(resp.core_updates.length > 3){
        setHasMore(true)
      }
    })
  }, []);

  function showMore(){
    setShowAll(true)
    setView(updates)
  }

  function showLess(){
    setShowAll(false)
    let u = [...updates]
    u.length = 3
    setView(u)
  }

  let link = <div></div>
  if(hasMore){
    if(showAll){
      link = <a onClick={showLess} style={{cursor:'pointer'}}><i className="fa fa-arrow-up"/> Hide</a>
    }
    else{
      link = <a onClick={showMore} style={{cursor:'pointer'}}><i className="fa fa-arrow-down"/> View More</a>
    }
  }

  return (
    <Modal
      title="Welcome to CORE"
      open={show}
      submittable={false}
      closeText={`Continue ${timeRemaining > 0 ? `(${timeRemaining})` : ""}`}
      canClose={timeRemaining < 1}
      disallowClickOutside={true}
      close={() => setShow(false)}
      onClose={() => updateSession({ viewed_beta_popup: true })}
      hideCloseX={true}
    >
      <div dangerouslySetInnerHTML={{ __html: html }} className="intro-modal-content"/>
      <hr style={{marginTop:'20px'}} />
      <div style={{textAlign:'center', marginTop:'40px', marginBottom:'15px'}}>
        <h4><strong>Recent Core Updates</strong></h4>
      </div>
      <div> 
        <table className="table table-striped">
          <thead>
            <tr>
              <td>Date</td>
              <td>Core Update</td>
            </tr>
          </thead>
          <tbody>
            {view.map((update) => {
              return (
                <tr key={update.id}>
                  <td>{update.pretty_date}</td>
                  <td>{update.info}</td>
                </tr>
              )
            })}        
          </tbody>
        </table>
      </div>
      <div className="text-right">
        {link}
      </div>
    </Modal>
  );
}

export default BetaPopup;



// WEBPACK FOOTER //
// ./app/javascript/components/home/BetaPopup.tsx